export const myTrans = (text) => {
    // Ở đây bạn có thể sử dụng logic dịch thuật, ví dụ: lấy text từ một file JSON hoặc từ API.
    // Hiện tại chỉ trả về chuỗi text gốc.
    return text;
};
// Function to save token to localStorage
export function saveToken(token) {
    if (typeof token === 'string') {
        localStorage.setItem('token', token);
    } else {
        console.error('Token should be a string.');
    }
}

export const convertNumberToVietnameseWords = (number) => {
    const ones = {
        0: 'không',
        1: 'một',
        2: 'hai',
        3: 'ba',
        4: 'bốn',
        5: 'năm',
        6: 'sáu',
        7: 'bảy',
        8: 'tám',
        9: 'chín'
    };

    const units = {
        0: '',
        1: 'nghìn',
        2: 'triệu',
        3: 'tỷ',
        4: 'nghìn tỷ',
        5: 'triệu tỷ',
        6: 'tỷ tỷ'
    };

    let result = '';
    number = parseInt(number);

    if (number === 0) {
        return ones[0];
    }

    let i = 0;
    do {
        let n = number % 1000;
        if (n !== 0) {
            let temp = '';

            if (n >= 100) {
                temp += ones[parseInt(n / 100)] + ' trăm ';
                n %= 100;
            }

            if (n >= 10) {
                if (n < 20) {
                    temp += 'mười ';
                    n %= 10;
                } else {
                    temp += ones[parseInt(n / 10)] + ' mươi ';
                    n %= 10;
                }
            } else if (n > 0 && temp !== '') {
                temp += 'lẻ ';
            }

            if (n > 0) {
                if (n === 1 && temp.includes('mươi')) {
                    temp += 'mốt ';
                } else if (n === 5 && temp.includes('mươi')) {
                    temp += 'lăm ';
                } else {
                    temp += ones[n] + ' ';
                }
            }

            temp += units[i];
            result = temp + ' ' + result;
        }

        number = parseInt(number / 1000);
        i++;
    } while (number > 0);

    return result.trim();
}



export async function captureDivAsImage(divId, nameFile = null, share = false) {
    // Tải thư viện html2canvas từ CDN nếu chưa có
    if (!window.html2canvas) {
        await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js'; // URL của CDN
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    // Tìm thẻ div bằng id
    const element = document.getElementById(divId);
    if (!element) {
        console.error(`Không tìm thấy thẻ div với id: ${divId}`);
        alert("Không tìm thấy nội dung cần chụp.");
        return;
    }

    // Hiển thị loading và thêm padding trước khi chụp ảnh
    const loadingElement = document.createElement('div');
    loadingElement.id = 'capture-loading';
    loadingElement.innerText = 'Đang tải...';
    loadingElement.style.position = 'fixed';
    loadingElement.style.top = '50%';
    loadingElement.style.left = '50%';
    loadingElement.style.transform = 'translate(-50%, -50%)';
    loadingElement.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    loadingElement.style.color = 'white';
    loadingElement.style.padding = '10px 20px';
    loadingElement.style.borderRadius = '5px';
    document.body.appendChild(loadingElement);

    // Thêm padding vào thẻ div
    element.style.padding = '15px';

    try {
        const nameDownload = nameFile || divId;

        // Sử dụng html2canvas để chụp ảnh phần tử
        const canvas = await window.html2canvas(element, { useCORS: true, allowTaint: true });

        // Chuyển đổi canvas thành hình ảnh
        const dataURL = canvas.toDataURL('image/png');
        const blob = await (await fetch(dataURL)).blob();
        console.log(blob);
        const file = new File([blob], `${nameDownload}.png`, { type: 'image/png' });

        if (share) {
            // Sử dụng Web Share API nếu có hỗ trợ để chia sẻ ảnh
            if (navigator.canShare && navigator.canShare({ files: [blob] })) {
                const file = new File([blob], 'image.jpg', { type: blob.type });
                await navigator.share({
                    files: [file],
                    title: 'Chia sẻ ảnh',
                    text: 'Đây là ảnh tôi muốn chia sẻ với bạn!'
                });
                console.log('Ảnh đã được chia sẻ thành công!');
            } else {
                alert("Thiết bị không hỗ trợ chia sẻ tệp.");
            }
        } else {
            // Nếu không yêu cầu chia sẻ, tải ảnh xuống
            const link = document.createElement('a');
            link.href = dataURL;
            link.download = `${nameDownload}.png`;
            link.click();
            console.log("Ảnh đã được tải xuống.");
        }
    } catch (error) {
        console.error('Lỗi khi chụp hoặc chia sẻ ảnh:', error);
        alert("Không thể chụp ảnh. Có thể có tài nguyên từ miền khác hoặc SVG phức tạp gây lỗi.");
    } finally {
        // Xóa loading và padding sau khi chụp ảnh
        document.body.removeChild(loadingElement);
        element.style.padding = '';
    }
}

export function formatNumber(num) {
    if(!num && num !== '') return 0;
    num = num.toString().replace(/[^0-9,]/g, '');
    let x = ",";
    let found = false; // biến đánh dấu xem đã tìm thấy ký tự x chưa

    num = num
        .split("") // chuyển chuỗi thành mảng
        .filter((c) => {
            if (c === x && !found) { // nếu đây là ký tự x và chưa tìm thấy ký tự x trước đó
                found = true; // đánh dấu là đã tìm thấy ký tự x
                return true; // giữ lại ký tự x đầu tiên
            }
            return c !== x; // loại bỏ tất cả các ký tự x khác
        })
        .join(""); // chuyển mảng kết quả thành chuỗi lại
    num = num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

    return num;
}


